// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --wrapper-gap: 1rem;
  display: grid;
  grid-template-rows: [header-start] min-content [header-end content-start] 1fr [content-end footer-start] min-content [footer-end];
  overflow: hidden;
  padding: 0 !important;
}
:host .host-component-wrapper {
  display: contents;
}
:host .host-component-wrapper .host-component-header {
  grid-row: header;
  overflow: visible;
  margin: 0 0.5rem 0.5rem 0.5rem;
}
:host .host-component-wrapper .host-component-body {
  grid-row: content;
  overflow: auto;
  display: grid;
  padding: var(--wrapper-gap);
}
:host .host-component-header-container {
  display: flex;
  gap: 0.5rem;
  padding-top: 0.5rem;
}
:host .host-component-footer.new-style {
  grid-row: footer;
  display: grid;
  grid-template-columns: [trash-start] 44px [trash-end back-start] 1fr [back-end cancel-start] 1fr [cancel-end submit-start] 1fr [submit-end continue-start] 1fr [continue-end info-start] 44px [info-end];
  gap: 0.5rem;
  border-top: 1px solid var(--gc-border-color);
  padding: 0.5rem 0;
  margin: 0 var(--wrapper-gap, 0.5rem);
}
:host .host-component-footer.new-style .button-trash {
  grid-column: trash;
}
:host .host-component-footer.new-style .button-prevStep {
  grid-column: back;
}
:host .host-component-footer.new-style .button-cancel {
  grid-column: cancel;
}
:host .host-component-footer.new-style .button-submit {
  grid-column: submit;
}
:host .host-component-footer.new-style .button-nextStep {
  grid-column: continue;
}
:host .host-component-footer.new-style .button-info {
  grid-column: info;
}
:host .host-component-footer:not(.new-style) {
  padding: 1rem;
  display: flex;
  flex-direction: row;
  background-color: var(--gc-background-color);
}
:host .host-component-footer:not(.new-style) .footer-btn {
  width: 33.33%;
}
:host .host-component-footer:not(.new-style) .footer-btn ::ng-deep .p-button {
  width: 100%;
  text-align: center;
}
:host .host-component-footer:not(.new-style) .button-nextStep, :host .host-component-footer:not(.new-style) .button-submit {
  margin-left: auto;
}
:host .host-component-footer:not(.new-style) .button-prevStep ~ .button-prevDraft, :host .host-component-footer:not(.new-style) .button-submit:has(~ .button-nextStep) {
  max-width: 25%;
}
:host .host-component-footer:not(.new-style) .button-submit ~ .button-nextStep, :host .host-component-footer:not(.new-style) .button-prevStep ~ .button-cancel {
  margin-left: initial;
}
:host .host-component-footer:not(.new-style) .button-cancel {
  margin-left: 33.33%;
  max-width: 25%;
}
:host .host-component-footer:not(.new-style) .button-delete ~ .button-cancel {
  margin-left: calc(33.33% - 30px);
  max-width: 25%;
}
:host .host-component-footer:not(.new-style) .button-delete {
  max-width: 50px;
}
:host .host-component-footer:not(.new-style) .button-delete, :host .host-component-footer:not(.new-style) .button-nextStep, :host .host-component-footer:not(.new-style) .button-prevStep, :host .host-component-footer:not(.new-style) .button-cancel, :host .host-component-footer:not(.new-style) .button-submit, :host .host-component-footer:not(.new-style) .button-prevDraft {
  padding-left: 5px;
  padding-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ngx-draft/lib/components/draft-host-component.sass"],"names":[],"mappings":"AAEA;EACI,mBAAA;EACA,aAAA;EACA,iIAAA;EACA,gBAAA;EACA,qBAAA;AADJ;AAEI;EACI,iBAAA;AAAR;AACQ;EACI,gBAAA;EACA,iBAAA;EACA,8BAAA;AACZ;AAAQ;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,2BAAA;AAEZ;AACI;EACI,aAAA;EACA,WAAA;EACA,mBAAA;AACR;AAEI;EACI,gBAAA;EACA,aAAA;EACA,wMAAA;EACA,WAAA;EAEA,4CAAA;EACA,iBAAA;EACA,oCAAA;AADR;AAGQ;EACI,kBAAA;AADZ;AAEQ;EACI,iBAAA;AAAZ;AACQ;EACI,mBAAA;AACZ;AAAQ;EACI,mBAAA;AAEZ;AADQ;EACI,qBAAA;AAGZ;AAFQ;EACI,iBAAA;AAIZ;AAFI;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;AAIR;AAHQ;EACI,aAAA;AAKZ;AAJY;EACI,WAAA;EACA,kBAAA;AAMhB;AAJQ;EACI,iBAAA;AAMZ;AAJQ;EACI,cAAA;AAMZ;AAJQ;EACI,oBAAA;AAMZ;AAJQ;EACI,mBAAA;EACA,cAAA;AAMZ;AAJQ;EACI,gCAAA;EACA,cAAA;AAMZ;AAJQ;EACI,eAAA;AAMZ;AAJQ;EAEQ,iBAAA;EACA,kBAAA;AAKhB","sourcesContent":["$iconButtonSize: 44px\n    \n:host\n    --wrapper-gap: 1rem\n    display: grid\n    grid-template-rows: [header-start] min-content [header-end content-start] 1fr [content-end footer-start] min-content [footer-end]\n    overflow: hidden\n    padding: 0 !important\n    .host-component-wrapper\n        display: contents\n        .host-component-header\n            grid-row: header\n            overflow: visible // allow focus outline to be visible\n            margin: 0 0.5rem 0.5rem 0.5rem\n        .host-component-body\n            grid-row: content\n            overflow: auto // allow focus outline to be visible\n            display: grid\n            padding: var(--wrapper-gap)\n            \n\n    .host-component-header-container\n        display: flex\n        gap: 0.5rem\n        padding-top: 0.5rem\n\n    // this effectively disables the button style as long as the footer does not have the '.new-style' class assigned\n    .host-component-footer.new-style\n        grid-row: footer\n        display: grid\n        grid-template-columns: [trash-start] $iconButtonSize [trash-end back-start]1fr [back-end cancel-start] 1fr [cancel-end submit-start] 1fr [submit-end continue-start] 1fr [continue-end info-start] $iconButtonSize [info-end] \n        gap: 0.5rem\n\n        border-top: 1px solid var(--gc-border-color)\n        padding: 0.5rem 0\n        margin: 0 var(--wrapper-gap, 0.5rem)\n\n        .button-trash\n            grid-column: trash\n        .button-prevStep\n            grid-column: back\n        .button-cancel\n            grid-column: cancel\n        .button-submit\n            grid-column: submit\n        .button-nextStep\n            grid-column: continue\n        .button-info\n            grid-column: info\n\n    .host-component-footer:not(.new-style)\n        padding: 1rem\n        display: flex\n        flex-direction: row\n        background-color: var(--gc-background-color)\n        .footer-btn\n            width: 33.33%\n            ::ng-deep .p-button\n                width: 100%\n                text-align: center\n\n        .button-nextStep, .button-submit\n            margin-left: auto\n\n        .button-prevStep ~ .button-prevDraft, .button-submit:has(~ .button-nextStep)\n            max-width: 25%\n\n        .button-submit ~ .button-nextStep, .button-prevStep ~ .button-cancel\n            margin-left: initial\n\n        .button-cancel\n            margin-left: 33.33%\n            max-width: 25%\n\n        .button-delete ~ .button-cancel\n            margin-left: calc(33.33% - 30px)\n            max-width: 25%\n\n        .button-delete\n            max-width: 50px\n\n        .button-delete, .button-nextStep, .button-prevStep, .button-cancel, .button-submit, .button-prevDraft\n            padding:\n                left: 5px\n                right: 5px"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
